import React, { Component } from "react";
import { Alert } from "@americanexpress/dls-react";
import FileUploader from "./FileUploader";
import { validateUploadFile, validationStateFromResult } from "../../util/uploadUtils";
import { UPLOAD_MESSAGES } from "../Common/constants";

class UkUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dragging: false,
      fileUk: null,
      filesUk: this.props.filesUk,
      invalidSize: false,
      invalidType: false,
      invalidPdf: false,
      invalidPdfMessage: "",
      isLoading: false,
    };
  }

  dragEventCounter = 0;

  dragenterListener = (event) => {
    this.overrideEventDefaults(event);
    this.dragEventCounter++;
    if (event.dataTransfer.items && event.dataTransfer.items[0]) {
      this.setState({ dragging: true });
    } else if (
      event.dataTransfer.types &&
      event.dataTransfer.types[0] === "Files"
    ) {
      this.setState({ dragging: true });
    }
  };

  dragleaveListener = (event) => {
    this.overrideEventDefaults(event);
    this.dragEventCounter--;

    if (this.dragEventCounter === 0) {
      this.setState({ dragging: false });
    }
  };

  dropListener = (event) => {
    let fileArrUk = this.state.filesUk;
    this.overrideEventDefaults(event);
    this.dragEventCounter = 0;
    this.setState({ dragging: false });

    if (event.dataTransfer.files && event.dataTransfer.files[0]) {
      this.checkValidity(event.dataTransfer.files[0], fileArrUk);
    }
  };

  overrideEventDefaults = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  onSelectFileClick = () => {
    this.fileUploaderInput && this.fileUploaderInput.click();
  };

  onFileChanged = (event) => {
    let { filesUk } = this.state;
    if (event.target.files && event.target.files[0]) {
      this.checkValidity(event.target.files[0], event.target.files);
    }
  };

  checkValidity = async (fileObj, fileArrUk) => {
    this.setState({ isLoading: true });
    const res = await validateUploadFile(fileObj);
    const validationErrors = validationStateFromResult(res);

    if (!res.valid) {
      this.setState({ ...validationErrors, isLoading: false });
      return;
    }

    this.setState({ ...validationErrors, isLoading: false });
    this.props.getFileUk(res.doc);
  };

  removeFile = (index) => {
    var filesUk = [];

    filesUk = this.props.filesUk;

    var array = filesUk;
    var pos = index;
    array.splice(pos, 1);
    this.setState({ filesUk: array });
  };

  componentDidMount() {
    window.addEventListener("dragover", (event) => {
      this.overrideEventDefaults(event);
    });
    window.addEventListener("drop", (event) => {
      this.overrideEventDefaults(event);
    });
  }

  componentWillUnmount() {
    window.removeEventListener("dragover", this.overrideEventDefaults);
    window.removeEventListener("drop", this.overrideEventDefaults);
  }

  render() {
    return (
      <FileUploader
        dragging={this.state.dragging}
        files={this.props.filesUk}
        isLoading={this.state.isLoading}
        onSelectFileClick={this.onSelectFileClick}
        onDrag={this.overrideEventDefaults}
        onDragStart={this.overrideEventDefaults}
        onDragEnd={this.overrideEventDefaults}
        onDragOver={this.overrideEventDefaults}
        onDragEnter={this.dragenterListener}
        onDragLeave={this.dragleaveListener}
        onDrop={this.dropListener}
        removeFile={this.removeFile}
        country={this.props.country}
      >
        {this.state.invalidSize && <Alert>{UPLOAD_MESSAGES.INVALID_SIZE}</Alert>}
        {this.state.invalidType && <Alert>{UPLOAD_MESSAGES.INVALID_TYPE}</Alert>}
        {this.state.invalidPdf && (
          <Alert>{this.state.invalidPdfMessage || UPLOAD_MESSAGES.INVALID_PDF}</Alert>
        )}
        <input
          ref={(el) => (this.fileUploaderInput = el)}
          type="file"
          className="fileUploader__InputUK"
          onChange={this.onFileChanged}
        />
      </FileUploader>
    );
  }
}

export default UkUpload;

